import './PaperlessBanner.scss';

import React, { Fragment } from 'react';

import { ReactComponent as Check } from 'assets/icons/check.svg';

const AllPaperless = () => (
  <Fragment>
    <div className="all-paperless-banner-view">
      <Check />
      <p>You have met the account service fee waiver criteria for e-delivery selections.</p>
    </div>
  </Fragment>
);

export default AllPaperless;
